import { ContentStatus } from '@monogrid/serverless-cms'
import { i18n as getI18n } from '@monogrid/vue-boost/i18n'
import type { MaybeComputedRef } from '@vueuse/shared'
import type { ComputedRef } from 'vue'
import { computed, unref } from 'vue'

export type QueryVariables = {
  variants?: boolean
  [key: string]: unknown
}

export function useQueryVariables (params: MaybeComputedRef<QueryVariables> = {}): ComputedRef {
  const i18n = getI18n()
  const variant = computed(() => (i18n.locale.value as string) === 'en' ? 'base' : i18n.locale.value)

  return computed(() => {
    const { variants = true, ...rest } = unref(params) as QueryVariables

    return {
      status: ContentStatus.PUBLISHED,
      ...rest,
      ...variants ? { variants: [variant.value] } : null
    }
  })
}
